<template>
  <div>
    <div class="container">
      <el-container  v-if="!isShow">
        <el-main style="overflow: visible !important;">
          <div class="container-box">
            <div class="container-box-header display-flex">
              <div class="display-flex-auto" v-for="(li ,index) in list" :class="{active:active === index}"
                   @click="check(index)">
                {{li.name}}
              </div>
            </div>
            <div v-if="active === 111">
              <leftContent></leftContent>
            </div>
            <div v-if="active === 1">
              <rightContent @modelId="modelId"></rightContent>
            </div>
          </div>
        </el-main>
      </el-container>
      <div class="nav-button">
        <!-- TODO id = 本身id -->
        <el-button type="primary" :id="li.id"  plain v-for="(li , index ) in arr" @click="showIfream(index)"  :key="index">{{li.name}}</el-button>
      </div>
      <div class="ifream-content" v-if="isShow">
        <iframe :src="src" frameborder="0"></iframe>
        <div style="position: absolute;top:20px;right: 20px" @click="isShow = false">
          <i  class="el-icon-error"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import leftContent from './left/left'
    import rightContent from './right/right'
    export default {
        components: {
            leftContent,
            rightContent,
        },
        data() {
            return {
                id:'',
                src:'',//地址
                isShow:false,
                active: 1,
                list: [
                    {name: "飞行任务信息"},
                    {name: "实验报告信息"},
                ],
                arr:[],
            }
        },
        methods: {

            modelId(data){
                // 判断id
                if (data.modelId){
                    for (let i in this.arr){
                        if(data.modelId  == this.arr[i].id){
                            document.getElementById(this.arr[i].id).style.background = 'green'
                            document.getElementById(this.arr[i].id).style.color = '#ffffff'
                        }
                    }
                }
            },
            //获取数据
            getData() {
                let params = {type: 1}
                this.$axios.get(this.URL.uModel.selectUModelList, {params}).then(res => {
                    if (res.status === 200) {
                        console.log(res);
                        this.arr =res.data

                    }
                })
            },

            check(index) {
                // this.active = index
            },
            showIfream(index){
                // this.isShow = true
                // this.src = this.arr[index].img_url
                window.open('#/webglTest?model3D='+this.arr[index].dir_name);
            }
        },
        created(){
            this.getData()
        }
    }
</script>

<style lang="less" scoped>
  .container {
    height: 100vh;
    .container-box {
      position: relative;
      width: 77%;
      margin: 1vh auto;
      .container-box-header {
        width: 100%;
        div {
          padding: 20px 0;
          border: 1px solid #333333;
          width: 50%;
          margin-left: -1px;
        }
        .active {
          background: #409EFF;
        }
      }
    }
  }
  .nav-button{
    position: fixed;
    width: 100px;
    top: 30px;
    right: 10px;
    .el-button+.el-button{
      margin: 0 !important;
    }
    .el-button{
      width: 100% !important;
    }
  }
  .ifream-content{
    z-index: 2;
    position: fixed;
    top:0;
    bottom:0;
    right: 0;
    left: 0;
    iframe{
      z-index: 3333;
      width: 100%;
      height: 100vh;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/main/dataCenter/labReport/details/details.vue